
export default {
  state:{
    //当前定位
    order:{},
  },
  mutations:{
    SET_ORDER:(state, order) => {
      console.log(order,'store-order');
      state.order = order;
    },
  },
  actions:{

  }
}
